// @flow
import { path } from 'ramda'

import { getChannelCategories } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_CHANNEL_CATEGORIES = 'channels/FETCH_CATEGORIES'

const fetchChannelCategoriesAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_CHANNEL_CATEGORIES,
    payload: getChannelCategories(publicApi, serviceSpec),
    meta: {
      ttl,
    },
  })
}

// eslint-disable-next-line complexity
export const fetchChannelCategories = (serviceSpec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchChannelCategoriesAction(serviceSpec))

  const state = getState()
  const expires = path(['channelCategories', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchChannelCategoriesAction(serviceSpec))
}
